export default __webpack_public_path__ + "static/media/Cuprum-Medium.b44a32c5.ttf";